import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { can, canZone, effectivePermissionDetails } from './policy';
import { modules } from './catalog';

export function hasPermission(user, flagOrModule, action = 'read') {
  if (flagOrModule === 'IsManager') return Boolean(user?.IsManager);
  if (flagOrModule === 'IsDevisManager') return Boolean(user?.EffectiveIsDevisManager || user?.IsDevisManager || user?.IsManager);
  const definition = modules.find(m => m.flag === flagOrModule || m.id === flagOrModule);
  return definition ? can(user, definition.id, action) : false;
}
export function usePermissions(moduleId) {
  const user = useSelector(state => state.user);
  const check = useCallback((targetOrAction = 'read', action = 'read') => moduleId
    ? can(user, moduleId, targetOrAction) : can(user, targetOrAction, action), [user, moduleId]);
  return {
    user, can: check,
    consultation: effectivePermissionDetails(user).consultation,
    zoning: canZone(user),
  };
}

export function pageModule(pathname, search = '') {
  if (pathname === '/avoir') {
    const view = new URLSearchParams(search).get('view');
    return view === 'demarque' ? 'demarque' : view === 'correctionstock' ? 'stockCorrections' : 'returns';
  }
  return ({ '/article': 'articles', '/client': 'clients', '/com': 'commercials', '/four': 'suppliers',
    '/famille': 'families', '/entrepot': 'warehouses', '/devis': 'quotes', '/bonliv': 'deliveryNotes',
    '/preparation': 'preparation', '/facture': 'invoices', '/reg': 'payments', '/exped': 'expedition',
    '/achat-commande': 'purchaseOrders', '/achat-reception': 'purchaseReceipts', '/facture-achat': 'purchaseInvoices',
    '/avoir-achat': 'purchaseReturns', '/transfert': 'transfers', '/inventaire': 'inventory',
    '/dashboard': 'operationsDashboard', '/dashboardrevenue': 'revenueDashboard', '/audit': 'audit', '/audit/logins': 'audit', '/drag': 'templates',
  })[pathname];
}
